<div class="performance-breakdown">
  <h3 class="performance-breakdown__title">
    Response time <span class="performance-breakdown__subtitle">(mean)</span>
    <div
      class="performance-breakdown__dropdown"
      *ngIf="!loading"
      ngbDropdown="ngbDropdown"
    >
      <p *ngIf="responseTypes.length === 1">
        Response type: {{ currentResponseType }}
      </p>
      <button
        class="btn btn-sm"
        *ngIf="responseTypes.length > 1"
        ngbDropdownToggle="ngbDropdownToggle"
        container="body"
        type="button"
      >
        Response type: {{ currentResponseType }}
      </button>
      <ul
        class="dropdown-menu--reduced-padding"
        *ngIf="responseTypes.length > 1"
        ngbDropdownMenu="ngbDropdownMenu"
      >
        <li
          *ngFor="
            let responseType of responseTypes;
            trackBy: responseTypeTrackBy
          "
        >
          <a
            uiSref="routes-show"
            [uiParams]="{ responseType: responseType }"
            ngbDropdownItem="ngbDropdownItem"
            ><i
              class="list-icon glyphicon"
              [ngClass]="{
                'glyphicon-check':
                  normalizeResponseType(responseType) === currentResponseType
              }"
            ></i
            >{{ normalizeResponseType(responseType) }}</a
          >
        </li>
      </ul>
    </div>
  </h3>
  <div class="performance-breakdown__loading" *ngIf="loading">
    <ab-spinner></ab-spinner>
  </div>
  <ul class="performance-breakdown__legends" *ngIf="!loading">
    <li
      class="time-legend"
      *ngFor="
        let breakdown of performanceBreakdowns;
        index as i;
        trackBy: performanceBreakdownTrackBy
      "
      (mouseover)="hoverIn(i)"
      (mouseout)="hoverOut()"
      [ngbTooltip]="breakdown.name"
    >
      <span
        class="time-legend__square"
        [ngStyle]="{ background: breakdown.color }"
      ></span>
      <p class="time-legend__text text-truncate">{{ breakdown.name }}</p>
      <p class="time-legend__percentage">
        <span *ngIf="breakdown.percentage === 0"
          >≈{{ breakdown.percentage }}%</span
        ><span *ngIf="breakdown.percentage >= 1"
          >{{ breakdown.percentage }}%</span
        >
      </p>
      <p class="time-legend__time">
        <ab-duration-format
          [milliseconds]="breakdown.timing"
        ></ab-duration-format>
      </p>
      <span
        class="time-legend__background"
        [ngStyle]="{
          background: breakdown.color,
          opacity: i === hoveredItem && breakdown.percentage > 0 ? 0.2 : 0
        }"
      ></span>
    </li>
  </ul>
  <div class="performance-breakdown__time" *ngIf="!loading">
    <p class="ab-card__data">
      <ab-duration-format
        *ngIf="performanceBreakdowns.length > 0"
        [milliseconds]="responseTime"
      ></ab-duration-format
      ><span *ngIf="performanceBreakdowns.length === 0">&mdash;</span>
      <ab-trend
        class="performance-breakdown__trend"
        [countList]="responseTimeList"
        [dur]="dur"
        [statType]="'response time'"
        [performanceTrend]="true"
      ></ab-trend>
    </p>
  </div>
  <div class="time-bar performance-breakdown__bkg-grey" *ngIf="!loading">
    <div
      class="time-bar__item"
      *ngFor="
        let breakdown of filterZeroPercentage(performanceBreakdowns);
        index as i;
        trackBy: performanceBreakdownTrackBy
      "
      [ngStyle]="{
        width: breakdown.percentage + '%',
        'background-color': breakdown.color
      }"
      (mouseover)="hoverIn(i)"
      (mouseout)="hoverOut()"
    >
      <div
        class="time-bar__item__arrow"
        [ngStyle]="{
          'border-top-color': breakdown.color,
          opacity: i === hoveredItem ? 1 : 0
        }"
      ></div>
    </div>
  </div>
</div>
